'use strict';

var React = require('react');
var _ = require('lodash');

var isJointAccount = require('../../utils/AccountTypes').checkIfJointAccount;

//constants
var YourDetailsConstants = require('../../constants/YourDetailsConstants');
var TrusteeTypes = YourDetailsConstants.TrusteeType;
var AppConstants = require('../../constants/ApplicationConstants');
var AccountType = AppConstants.AccountTypeCodes;
var ProductIds = AppConstants.ProductIds;

//Stores
var YourDetailsStore = require('../../stores/YourDetailsStore');

var YourDetailsActions = require('../../actions/YourDetailsActions');

//components
var Investor = require('./Investor.jsx');
var CorporateTrustee = require('./CorporateTrustee.jsx');
var IndividualAnnuityTrustee = require('./IndividualAnnuityTrustee.jsx');
var AddAdditionalInvestors = require('./AddAdditionalInvestors.jsx');
var CompanyInvestor = require('./CompanyInvestor.jsx');
var RadioInput = require('../Common/RadioInput.jsx');

var InvestorsSection = React.createClass({
    propTypes: {
        formKey: React.PropTypes.string
    },
    getStateFromStores() {
      var list = YourDetailsStore.getInvestorList();
      if (list.length === 0) {
        list = YourDetailsStore.getTrusteeList();
      }
        return {
            investorList: list,
            investorLimitReached: YourDetailsStore.getInvestorLimitReached(),
            tfnExemptionList: YourDetailsStore.getTfnExemptionList(),
            titleList: YourDetailsStore.getTitleList(),
            errorList: YourDetailsStore.getErrorList()
        };
    },
    getStateFromAccountType(isInvestor, accountType) {
        var state = {}
        if (isInvestor){
            state = {isInvestor: true,
                     section: 'ydInvestor',
                     subHeader: (accountType === AccountType.JOINT) ? 'Investor' : 'Individual',
                     showAddInvestor: (this.props.productId === AppConstants.ProductIds.INVESTMENT)}
        }else{
            state = {isInvestor: false,
                     section: 'ydTrustee',
                     subHeader: 'Trustee',
                     showAddInvestor: true}
        }
        return state;
    },
    getInitialState: function () {
        return this.getState(this.props);
    },

    getState: function(props) {
      var isInvestor = (props.accountType === AccountType.COMPANY || props.accountType === AccountType.JOINT || props.accountType === AccountType.PARTNERSHIP);
      return _.assign(this.getStateFromStores(), this.getStateFromAccountType(isInvestor, props.accountType));
    },
    
    // Add change listeners to stores
    componentDidMount: function () {
        YourDetailsStore.addChangeListener(this._onChange);
    },

    // Remove change listers from stores
    componentWillUnmount: function () {
        YourDetailsStore.removeChangeListener(this._onChange);
    },

    componentWillReceiveProps: function(nextProps) {
        if (this.props.productId !== nextProps.productId || this.props.accountType !== nextProps.accountType){
            this.setState(this.getState(nextProps));
        }
    },

    _onChange: function () {
        this.setState(this.getStateFromStores());
    },

    _individualInvestor(data, index) {
      return (<Investor data={data} 
                        productId={this.props.productId}
                        accountType={this.props.accountType}
                        index={index}
                        titleList={this.state.titleList} 
                        tfnExemptionList={this.state.tfnExemptionList}
                        errorList={this.state.errorList}
                        section={this.state.section} />);
    },
    _renderIndividualTrustee(data, index){
        if (this.props.productId === ProductIds.INVESTMENT){
            if (this.props.accountType === AccountType.COMPANY || this.props.accountType === AccountType.PARTNERSHIP){
              return (<CompanyInvestor data={data}
                                       index={index}
                                       productId={this.props.productId}
                                       accountType={this.props.accountType}
                                       titleList={this.state.titleList}
                                       errorList={this.state.errorList}
                                       section={this.state.section} />);
            }else{
              return this._individualInvestor(data, index);
            }
        }else if (this.props.productId === ProductIds.COMMINSURE || this.props.productId === ProductIds.CHALLENGER){
            if (this.props.accountType === AccountType.JOINT){
              return this._individualInvestor(data, index);
            }else{
              return (<IndividualAnnuityTrustee data={data}
                                               index={index}
                                               productId={this.props.productId}
                                               titleList={this.state.titleList}
                                               tfnExemptionList={this.state.tfnExemptionList}
                                               accountType={this.props.accountType}
                                               errorList={this.state.errorList}
                                               section={this.state.section} />);
            }
        }
    },

    _renderCorporateTrustee(data, index){
        var abnLabel = 'ABN/ARBN/ARSN';
        if (this.props.accountType === AccountType.SMSF){
            abnLabel = 'ABN/ACN/ARSN';
        }
        return (<CorporateTrustee data={data} 
                                  abnLabel={abnLabel}
                                  index={index}
                                  productId={this.props.productId}
                                  accountType={this.props.accountType}
                                  errorList={this.state.errorList}
                                  section={this.state.section} />);
    },

    _renderTrusteeDeleteLink(index){
      return (<a id={'trusteeX' + index} className="pull-right trustee-delete" onClick={this.deleteTrustee.bind(this, index)}><i className="icon icon-cancel" /></a>);
    },

    _renderTrusteeType(data, index){
      if ((this.props.accountType === AccountType.SMSF || this.props.accountType === AccountType.TRUST) && this.props.productId === ProductIds.INVESTMENT){
        return (<RadioInput label="Select trustee type"
                            id={`ydTrusteetrusteeType${index}`}
                            data={YourDetailsConstants.TrusteeTypeData}
                            onChange={this.handleTrusteeTypeChange.bind(this, index)}
                            value={(data) ? data.trusteeType : undefined}
                            isHidden={this.state.hideTrusteeType}
                            errorList={this.state.errorList} />);
      }
    },

    _renderRepeatingSection(data, index){
      if (data){
        return (data.trusteeType === TrusteeTypes.CORPORATE) ? this._renderCorporateTrustee(data,index) : this._renderIndividualTrustee(data, index);
      }
    },

    handleTrusteeTypeChange: function (index, e) {
        if (e.target.value === TrusteeTypes.CORPORATE) {
            YourDetailsActions.addTrustee(true, index);
        }
        else {
            YourDetailsActions.addTrustee(false, index);
        }
    },

    render: function () {
        return (
            <div>
                {this.state.investorList.map(function (data, index) {
                    return (<div className="sub-section" key={'ydMultipleInvestor' + index }>
                                {(!isJointAccount(this.props.accountType) && index > 0) ? this._renderTrusteeDeleteLink(index) : null}
                                {(isJointAccount(this.props.accountType) && index > 1) ? this._renderTrusteeDeleteLink(index) : null}
                                <h4>{this.state.subHeader + ' ' + (index + 1)}</h4>
                                {this._renderTrusteeType(data, index)}
                                {this._renderRepeatingSection(data, index)}
                            </div>);
                }.bind(this))}
                <div className="sub-section">
                  {this.state.showAddInvestor ? <AddAdditionalInvestors formKey={this.props.formKey} isHidden={this.state.investorLimitReached} /> : null}
                </div>    
            </div>
        );
    },

    deleteTrustee(index){
      YourDetailsActions.deleteTrustee(index);
    }

});


/// This is the entry point of additional investors including Joint, Trustee details of SMSF/TRUST, Company Investors.
/// Your details store has 2 list for investors, investor list and trustee list.
/// Investor list is for Comapny and Joint and Trustee list is for SMSF and TRUST.

module.exports = InvestorsSection;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/YourDetails/InvestorsSection.jsx